<template>
  <Modal 
    v-model="dialogVisible" 
    width="1150px" 
    :maskClosable = "false"  
    :keyboard = "false"
    :forceRender = "true" 
    :zIndex = "9000"
    top="20px"
  >
    <div class = "edit_container">
      <div class="edit__header">
        <div class="edit__header__name">{{ reportName }}</div>
        <div class="edit__header__course" @click = "dialogVisible_report = true">
          <img src="/static/icon/course.png" alt="" style="width: 18px;">
          <span class="mk-link" style="margin-left: 5px">教程</span>
        </div>
      </div>
      <Editor ref="Editor" />
      <ReportCourseDialog :dialogVisible = "dialogVisible_report" @close = "dialogVisible_report = false" />
    </div>
    <div slot="footer" align="center">
      <el-button size="small" style="width: 100px;background: #269D7B;color: #fff;" :disabled="btnDisabled"  @click="handleSave">保存</el-button>
    </div>
  </Modal>
</template>

<script>
import Editor from '@/components/mk-editor/Editor'
import { Modal } from "ant-design-vue"
import ReportCourseDialog from "./report-course-dialog"
export default {
  components: {Editor,Modal,ReportCourseDialog},
  props: {},
  created() {},
  data() {
    return {
      loading: false,
      dialogVisible: false,
      reportName: '',
      dialogVisible_report: false,
      btnDisabled: false,
    }
  },
  methods: {
    handleOpen(reportName,html) {
      console.log(reportName);
      this.dialogVisible = true
      this.btnDisabled = false
      this.reportName = reportName
      // 弹框打开后判断有无历史未完成的编辑
      const stu = this.checkTemporary()
      if(html && !stu) {
        this.setEngineValue(html)
      }
    },
    // 检测临时任务
    checkTemporary() {
      let ret = false
      const _this = this
      const tempHTML = localStorage.getItem(this.getNowCID())
      if(tempHTML) {
        Modal.confirm({
          title: () => '系统检测到有上次编辑未完成的任务，是否恢复？',
          zIndex: 9001,
          cancelText: '忽略',
          okText: '确定',
          centered: true,
          onOk() {
            _this.setEngineValue(tempHTML)
            ret = true
          },
          onCancel() {
            localStorage.removeItem(_this.getNowCID())
          },
          class: 'test',
        });
      }
      return ret
    },
    setEngineValue(html) {
      this.$nextTick(() => {
        this.$refs.Editor.set_engineValue(html)
      })
    },
    // 获取当前账套的cid
    getNowCID() {
      return JSON.parse(sessionStorage.getItem('cid'))
    },
    handleSave() {
      this.btnDisabled = true
      const data = this.$refs.Editor.getValue()
      // 保存临时编辑的任务
      const cid = this.getNowCID()
      localStorage.setItem(cid,data.value)
      this.$emit('save',data)
      this.dialogVisible = false
    },
  }
}
</script>

<style lang='less' scoped>
  .edit__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px 30px 0;
    &__name {
      font-size: 18px;
      font-weight: 600;
    }
    &__course {
      display: flex;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/ProjectReportEditor.vue